/** v1.2.0菜单
 * 字段说明：
 * @param {string} path       - 路由路径
 * @param {string} title      - 菜单显示名称
 * @param {boolean} isWindowOpen - 是否以新窗口方式打开
 */
const menuList = [
  {
    title: 'GEO分析',
    children: [
      {
        path: '/home/analytical/brand',
        icon: 'brand',
        title: '品牌分析',
      },
      {
        path: '/home/analytical/deepInsight',
        icon: 'deepInsight',
        title: '深度品牌洞察',
        showCondition: ['inner'], // 限制只有内贸存在
      },
      {
        path: '/form',
        icon: 'report',
        title: '网站分析',
        isWindowOpen: true,
      },
      {
        path: '/home/analytical/manage',
        icon: 'reportManage',
        title: '网站分析报告',
      },
    ],
  },
  {
    title: 'GEO智能助手',
    children: [
      {
        path: '/home/workbench',
        icon: 'workbench',
        title: '工作台',
      },
      // {
      //   path: '/home/aiTrack',
      //   icon: 'aiTrack',
      //   title: 'AI引用追踪',
      //   showCondition: ['inner'], // 限制只有内贸存在
      // },
      {
        path: '/home/sourceInsight',
        icon: 'sourceInsight',
        title: '信源洞察',
        showCondition: ['inner'], // 限制只有内贸存在
      },
      {
        path: '/home/industryInsight',
        icon: 'industryInsight',
        title: '行业洞察',
        showCondition: ['inner'], // 限制只有内贸存在
      },
      {
        path: '/home/knowledge',
        title: '知识库管理',
        children: [
          {
            path: '/home/knowledge/index',
            icon: 'knowledge',
            title: '企业知识库',
          },
          {
            path: '/home/knowledge/resource',
            icon: 'resource',
            title: '资源库',
          },
          {
            path: '/home/knowledge/prompt',
            icon: 'prompt',
            title: '提示词库',
          },
          {
            path: '/home/knowledge/command',
            icon: 'command',
            title: '指令库',
          },
        ],
      },
      {
        path: '/home/media',
        title: '内容创作',
        children: [
          {
            path: '/home/media/task',
            icon: 'creationTask',
            title: '创作文章',
          },
          {
            path: '/home/media/manage',
            icon: 'articleManage',
            title: '内容管理',
          },
        ],
      },
      {
        path: '/home/statistical',
        title: '内容发布',
        children: [
          {
            path: '/home/statistical/account',
            icon: 'accManage',
            title: '账号管理',
            showCondition: ['inner'], // 限制只有内贸存在
          },
          {
            path: '/home/statistical/send',
            icon: 'send',
            title: '发布管理',
          },
        ],
      },
      {
        path: '/home/statistical',
        title: '统计报表',
        children: [
          {
            path: '/home/statistical/data',
            icon: 'statistical',
            title: '上词统计',
          },
          {
            path: '/home/statistical/month',
            icon: 'month',
            title: '月报管理',
          },
          {
            path: '/home/equity-detail',
            icon: 'statistical',
            title: '权益明细',
          },
        ],
      },
    ],
  },
  {
    path: '/form?type=3',
    isWindowOpen: true,
    title: '运营托管',
    showCondition: ['inner'], // 限制只有内贸存在
    children: [
      {
        path: '/form?type=3',
        icon: 'operation',
        isWindowOpen: true,
        title: 'GEO运营托管',
      },
    ],
  },
]
export default menuList
